module.exports = __webpack_public_path__ + "static/media/icons.7e149c6e.svg";